import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fw-800 fs-9 text-success" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref, inject, computed, watch } from "vue";
import ApiService from "@/core/services/Downlines.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";

import type Node from "element-plus/es/components/tree/src/model/node";
import type { DragEvents } from "element-plus/es/components/tree/src/model/useDragNode";
import type {
  AllowDropType,
  NodeDropType,
} from "element-plus/es/components/tree/src/tree.type";


export default /*@__PURE__*/_defineComponent({
  __name: 'UplineTree',
  props: {
  modelValue: Boolean,
  selectUser: Object,
},
  setup(__props, { emit: __emit }) {

const $loading = inject("$loading") as LoadingService;

const items = ref<{
  data: { total_levels: number; tree: RawTreeNode[] };
} | null>(null);

const props = __props;

const emit = __emit;

const isDialogUplineTree = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const handleDialogClose = () => {
  items.value = null;
  emit("update:modelValue", false);
};

const getDetail = async (user: any) => {
  $loading.startLoading();
  try {
    const resp = await ApiService.uplineTree(user);
    if (resp.status === "success") {
      items.value = resp;
    } else {
      emit("update:modelValue", false);
    }

    ElNotification({
      title: resp.status,
      message: resp.msg,
      type: resp.status,
    });
  } catch (error) {
    // console.error("Error fetching tree data:", error);
    ElNotification({
      title: "Error",
      message: "Failed to load tree data.",
      type: "error",
    });
  }
  $loading.endLoading();
};

watch(
  () => props.selectUser,
  (newVal) => {
    if (newVal) {
      getDetail(newVal);
    }
  },
  { immediate: true }
);

const formattedTreeData = computed(() => {
  if (!items.value?.data?.tree) return [];
  const sortedNodes = [...items.value.data.tree].sort(
    (a, b) => a.level - b.level
  );
  return sortedNodes.map((node) => formatNode(node));
});

const formatNode = (node: any) => {
  const label = `${node.level}: ${node.username}`;
  return {
    ...node,
    label: label + (node.nickname ? ` (${node.nickname})` : ""),
    children: node.children
      ? node.children.map((child) => formatNode(child))
      : [],
  };
};

return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isDialogUplineTree.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDialogUplineTree).value = $event)),
    width: "500",
    "destroy-on-close": "",
    center: "",
    onClose: handleDialogClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          variant: "flat",
          size: "small",
          rounded: "md",
          type: "danger",
          onClick: handleDialogClose
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Close")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (formattedTreeData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, " Total Levels: " + _toDisplayString(items.value?.data?.total_levels ?? 0), 1),
            _createVNode(_component_el_tree, {
              style: {"max-width":"600px"},
              data: formattedTreeData.value,
              "default-expand-all": "",
              "node-key": "id"
            }, null, 8, ["data"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})